<div class="result-per-page">
  <button class="rpp-container reset-btn" (click)="overlay.popover.toggle($event)">
    <span>{{ rpp() }}</span>
    <sxw-svg-icon name="arrow-down" width="20" height="20" strokeColor="var(--p-gray-700)" />
  </button>
  <div class="total-results">{{ total() }} {{ "COMMON.PAGINATION.RESULTS" | translate }}</div>
  <sxw-overlay-panel #overlay>
    <sxw-overlay-menu-list [items]="rppOptions()" dataKey="value" title="COMMON.PAGINATION.RESULT_PER_PAGE">
      <ng-template #menuItem let-item="item">
        <sxw-overlay-menu-item [label]="item.label" (itemClicked)="changeRPP(item)" [class.active]="rpp() === item.value" />
      </ng-template>
    </sxw-overlay-menu-list>
  </sxw-overlay-panel>
</div>

<!--Start Pagination -->
<div class="pagination-actions">
  @if (showArrows()) {
    <!--    @if (showStartEndArrows()) {-->
    <!--      <sxw-svg-icon-->
    <!--        [fillColor]="page() > 1 ? 'black' : '#ccc'"-->
    <!--        class="icon"-->
    <!--        (click)="goToFirstPage()"-->
    <!--        name="left-double"-->
    <!--        width="15"-->
    <!--        height="15" />-->
    <!--    }-->
    <button class="reset-btn pagination-action pagination-action-back" type="button" [class.disabled]="page() <= 1" (click)="goToPrevPage()">
      <sxw-svg-icon
        [fillColor]="page() > 1 ? 'var(--p-gray-700)' : 'var(--p-gray-400)'"
        [strokeColor]="page() > 1 ? 'var(--p-gray-700)' : 'var(--p-gray-400)'"
        class="icon"
        name="arrow-left"
        width="20"
        height="20" />
    </button>
  }

  <div class="pagination-pages-actions">
    @if (page() > 1) {
      <button class="reset-btn item" type="button" (click)="changePage(page() - 1)">
        {{ page() - 1 }}
      </button>
    }

    <button class="reset-btn item active" type="button" (click)="changePage(page())">{{ page() }}</button>

    @if (page() + 1 <= totalPages()) {
      <button class="reset-btn item" type="button" (click)="changePage(page() + 1)">
        {{ page() + 1 }}
      </button>
    }

    @if (page() === 1 && total() > page() + 2 * rpp()) {
      <button class="reset-btn item" type="button" (click)="changePage(page() + 2)">
        {{ page() + 2 }}
      </button>
    }

    @if (page() + 4 < totalPages() - 1) {
      <button class="reset-btn item pagination-item-clip" type="button" (click)="changePage(totalClipPages())">
        {{ totalClipPages() }}
      </button>
    }

    @if (totalPages() > 3 && page() !== totalPages() && page() + 1 !== totalPages()) {
      <button class="reset-btn item pagination-item-total" type="button" (click)="changePage(totalPages())">
        {{ totalPages() }}
      </button>
    }
  </div>

  @if (showArrows()) {
    <button
      class="reset-btn pagination-action pagination-action-next"
      type="button"
      [class.disabled]="page() + 1 >= totalPages()"
      (click)="goToNextPage()">
      <sxw-svg-icon
        [fillColor]="page() + 1 < totalPages() ? 'var(--p-gray-700)' : 'var(--p-gray-400)'"
        [strokeColor]="page() + 1 < totalPages() ? 'var(--p-gray-700)' : 'var(--p-gray-400)'"
        class="icon"
        name="arrow-right"
        width="20"
        height="20" />
    </button>

    <!--    @if (showStartEndArrows()) {-->
    <!--      <sxw-svg-icon-->
    <!--        [fillColor]="page() < totalPages() ? 'black' : '#ccc'"-->
    <!--        class="icon"-->
    <!--        (click)="goToLastPage()"-->
    <!--        name="right-double"-->
    <!--        width="13"-->
    <!--        height="13" />-->
    <!--    }-->
  }
</div>

<!--<div class="pagenation-right d-flex flex-row justify-content-start gap-10">-->
<!--  @if (showPageNumberInput()) {-->
<!--    <div class="page-number d-flex flex-row justify-content-start gap-10 align-items-center">-->
<!--      <span> {{ "COMMON.PAGINATION.PAGE_NUMBER" | translate }} </span>-->
<!--      <input #input [(ngModel)]="pageNumber" (change)="handleInput(pageNumber())" class="inputStyle"-->
<!--             [style.minWidth.ch]="input.value.length + 2" />-->
<!--    </div>-->
<!--  }-->
<!--</div>-->
<!--End Pagination -->
